(() => {
  const init = () => {
    const section = document.querySelector('.section-sets-our');
    if (!section) return;

    const cards = Array.from(section.querySelectorAll('.card-tab'));
    if (!cards.length) return;

    let openCard = null;

    const closeCard = (card) => {
      card.classList.remove('is-open');
      card.setAttribute('aria-expanded', 'false');
    };

    const open = (card) => {
      if (openCard && openCard !== card) {
        closeCard(openCard);
      }
      card.classList.add('is-open');
      card.setAttribute('aria-expanded', 'true');
      openCard = card;
    };

    cards.forEach((card, index) => {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-expanded', 'false');
      card.setAttribute('aria-label', `Open card ${index + 1}`);

      const toggle = () => {
        if (card.classList.contains('is-open')) {
          closeCard(card);
          openCard = null;
        } else {
          open(card);
        }
      };

      card.addEventListener('click', toggle);
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
